"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Avatar = require("./Avatar");
Object.keys(_Avatar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Avatar[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Avatar[key];
    }
  });
});
var _AvatarColorHelper = require("./AvatarColorHelper");
Object.keys(_AvatarColorHelper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AvatarColorHelper[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AvatarColorHelper[key];
    }
  });
});
var _AvatarGroup = require("./AvatarGroup");
Object.keys(_AvatarGroup).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AvatarGroup[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AvatarGroup[key];
    }
  });
});
var _BrandedAvatar = require("./BrandedAvatar");
Object.keys(_BrandedAvatar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BrandedAvatar[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _BrandedAvatar[key];
    }
  });
});